<script>
/**
 * Concept Quicktable
 * 
 * @Version 1.0
 * @Author Daniel Lepe
 */
import {captions, baseIndex as fetchingAPI} from './archetype.js'

import QuickCardFooter from '@/views/elements/quick-card-footer.vue'
import axios from 'axios'
import automodal from './automodal.vue'

let name = 'ElementosnutricionalesQuicktable',
    newButtonLabel = 'New',
    emptyHeader = 'Data not found',
    emptyLead =  'Module empty',
    reloadData = 'Try reloading this page',
    tryAgainLater  = '',
	header = null,
	footer = null;

export default {
	name,

    components: {automodal, QuickCardFooter},

	props: {
		fetchingAPI: {
			type: String,
			default: () => { return fetchingAPI }
		},
		header: {
			type: String,
			default: () => { return header }
		},
		perPage: {
			type: Number,
			default: 10,
		},
		footer: {
			type: String,
			default: () => { return footer }
		},
		captions: {
			type: [Array, Object],
			default: () => captions
		}
	},
	
	computed: {
		sourceURI() {
			let init = this.fetchingAPI + "/" + this.perPage + "/" + this.currentPage;
			if (!!this.term) {
				init += "/" + this.term;
			} else if (!this.term || this.term == "s") {
				init += "/@";
			}
			return init;
		}
	},
	
	data: () => {
		return {
			name, newButtonLabel, emptyHeader,
            emptyLead, tryAgainLater, reloadData,
			currentPage: 1,
			items: [],
			itemsCount: 0,
			term: null,
			isLoading: false
		}
	},
	
	methods: {
        async refreshFromStart(){
            this.currentPage = 1
            this.refresh()
        },
		async refresh(){
			this.isLoading = true
			await this.loadUp()
			this.isLoading = false
		},
		async loadUp(){
			try {
				let response = await axios.get(this.sourceURI)
				this.items = response.data.rows;
				this.itemsCount = response.data.count;
				this.loading = false;
			} catch (error) {
				console.error(error)
			}
		}
	},

	watch: {
		currentPage(a, b) {
			this.refresh();
		},
		'$route'(){
			this.loadUp()
		}
	},

	mounted() {
        this.refresh()
	}
};
</script>

<template>
	<div :id="name">

		<b-card no-body>

            <!-- TABLE CONTENT -->
            <b-table v-if="items.length && !isLoading" class="animated fadeIn" responsive :items="items" :fields="captions">

				<template #cell(costo)="data">
                    {{data.value | currency}}
				</template>

				<template #cell(imagenes_id_avatar)="data">
                    <api-img-pristine :comp="data.value" size="128/128" :thumbnail="true" :allow-zoom="true"/>
				</template>

				<template #cell(_)="data">
                    <automodal :concept-id="data.item.id_pk" @refresh="refresh">
						Editar
					</automodal>
				</template>

			</b-table>

            <!-- LOADING SPINNER -->

			<div v-if="isLoading">
				<div class="text-center p-5">
					<b-spinner variant="primary" />
				</div>
			</div>

            <!-- EMPTY JUMBOTRON -->

            <div v-else-if="!items.length" class="pt-4 pl-4 pr-4 pb-0">
                <b-jumbotron :header="emptyHeader" :lead="emptyLead">
                    <p>{{tryAgainLater}}</p>
                    <b-button variant="primary" @click="refresh()">{{reloadData}}</b-button>
                </b-jumbotron>
            </div>

            <!-- HEADER -->

            <template v-slot:header>
				<b-row align-h="between">

					<b-col md="auto" v-if="!!header">
						<h6 class="mt-2 mb-2">{{header}}</h6>
					</b-col>

					<b-col>
                        <b-input-group>
                            <b-form-input v-model="term" @keyup.enter="refreshFromStart()" placeholder="Buscador..." />
                            <b-input-group-append>
                                <b-button v-if="!!term"  variant="secondary" @click="term = ''; refreshFromStart();"><i class="fa fa-times"></i></b-button>
                                <b-button variant="secondary" @click="refreshFromStart()" :disabled="!term"><i class="fa fa-search"></i></b-button>
                            </b-input-group-append>
                        </b-input-group>
					</b-col>

					<b-col md="auto" class="align-right">
						<automodal @refresh="refresh">
							Nuevo
						</automodal>
					</b-col>

				</b-row>
			</template>

            <!-- FOOTER -->

			<template v-slot:footer v-if="!isLoading && items.length">
				<quick-card-footer :items-count="itemsCount" :per-page="perPage" v-model="currentPage" @refresh="refresh" :items-fetched="items.length"/>
			</template>

		</b-card>

	</div>
</template>